import { render, staticRenderFns } from "@/agilis/components/DataTableV2/DataTableV2ItemEdit/DataTableV2ItemEdit.html?vue&type=template&id=77cacdc7&external"
import script from "./ContactTableItemEdit.js?vue&type=script&lang=js&external"
export * from "./ContactTableItemEdit.js?vue&type=script&lang=js&external"
import style0 from "@/agilis/components/DataTableV2/DataTableV2ItemEdit/DataTableV2ItemEdit.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import VBtn from '@/agilis/wrappers/VBtn/VBtn.vue'
import VCard from '@/agilis/wrappers/VCard/VCard.vue'
installComponents(component, {VBtn,VCard})
